<template>
  <div>
    <NotificationReminderContainer
      :reports="reports"
      :feature-name="NOTIFICATION_FEATURES_NAME.SECTION_STUDENT"
    />
  </div>
</template>

<script>
import NotificationReminderContainer from '@/src/components/Settings/notifications/NotificationReminderContainer.vue'
import NOTIFICATION_FEATURES_NAME from '@src/constants/notification-constants.js'
export default {
  components: {
    NotificationReminderContainer,
  },
  data() {
    return {
      NOTIFICATION_FEATURES_NAME,
      reports: ['monthly'],
    }
  },
}
</script>
